import {
  createImageUrlBuilder,
  type SanityImageSource,
} from "@sanity/image-url";
import Image from "next/image";
import { ComponentProps } from "react";

import { ImageProps } from "../types/image";
import { client } from "./client";

const builder = createImageUrlBuilder(client);

function urlFor(source: SanityImageSource) {
  return builder.image(source);
}

export function buildImageProps(
  image: ImageProps,
  options: { width?: number } = {},
): ComponentProps<typeof Image> {
  return {
    src: urlFor(image)
      .auto("format")
      .width(options.width ?? 2000)
      .url(),
    alt: image.alt,
    // @ts-ignore
    blurDataURL: image.asset.metadata?.lqip,
  };
}
